
import React from 'react'
import './aiquiz.css'
import { Delete, Check, Cancel} from "@mui/icons-material"
import StatusContext from '../../../contexts/StatusContext'
import { CancelIcon } from '../customicons/CancelIcon';
import { CheckIcon } from '../customicons/CheckIcon';
import { CircleIcon } from '../customicons/CircleIcon';
import {ScrollTextAnswer} from "../scrolltext/ScrollTextAnswer"


export const DisplayQuiz = ({ displayprompt, onDeletePrompt, onCancelDelete, onAcceptDelete, onSubmitAnswer, onAcceptAnswer, onResetAnswer, showprompts }) => {
  let {
    isLoading,
    } = React.useContext(StatusContext); 
    

  return (
    <div disabled={isLoading} >
      {
        <div key={displayprompt.id}>
          {
            showprompts &&  
            <div className="quizTextPrompt" >
              {
                (displayprompt.response.delete === true) ?
                  <>
                    <Cancel className="promptIcon"  onClick={() => { !isLoading && onCancelDelete(displayprompt) }} />
                    <Check className="promptIcon"  onClick={() => { !isLoading && onAcceptDelete(displayprompt)}} />
                  </>
                  : <Delete className="promptIcon"  onClick={() => { !isLoading && onDeletePrompt(displayprompt) }} />
              }
              {displayprompt.prompt}
            </div>
          }

         
          {displayprompt.response && (
          <>
            {
                displayprompt.response.answer[0][0] && (
                  <>
                  <div className="promptTextPrompt, flex-container">
                    {
                      
                      (displayprompt.response.answer[0][1] === true) &&
                        <>
                          {
                            <>
                            {
                            (displayprompt.response.answer[0][2] === true && displayprompt.response.answer[0][3] === true ) &&
                              <CheckIcon />
                            }
                            {
                            (displayprompt.response.answer[0][2] === true && displayprompt.response.answer[0][3] === false ) &&
                            <CancelIcon />
                            }
                            </>
                          }
                          {
                            displayprompt.response.answer[0][2] === false &&
                                <>
                                    <CheckIcon onClick={() => { onAcceptAnswer(displayprompt, displayprompt.response.answer[0][0]) }} />
                                    <CancelIcon onClick={() => { onResetAnswer(displayprompt, displayprompt.response.answer[0][0]) }} />
                                </>
                          }
                        </>
                    }

                    {
                        (displayprompt.response.answer[0][1] === false) &&
                        <CircleIcon onClick={() => { !isLoading && onSubmitAnswer(displayprompt.id, displayprompt.response, displayprompt.response.answer[0][0]) }}></CircleIcon>
                    }

                   
                    <ScrollTextAnswer text={displayprompt.response.answer[0][0]}/>
                    
                  </div>
                </>
                )
            }
            {
                displayprompt.response.answer[1][0] && (
                  <>
                  <div className="promptTextPrompt, flex-container">

                    {
                      
                      (displayprompt.response.answer[1][1] === true) &&
                        <>
                          
                            {
                            (displayprompt.response.answer[1][2] === true && displayprompt.response.answer[1][3] === true ) &&
                              <CheckIcon/>
                            }
                            {
                            (displayprompt.response.answer[1][2] === true && displayprompt.response.answer[1][3] === false ) &&
                              <CancelIcon/>
                            }
                          {
                            displayprompt.response.answer[1][2] === false &&
                                <>
                                    <CheckIcon onClick={() => { onAcceptAnswer(displayprompt, displayprompt.response.answer[1][0]) }} />
                                    <CancelIcon onClick={() => { onResetAnswer(displayprompt, displayprompt.response.answer[1][0]) }} />
                                </>
                          }
                        </>
                    }

                    {
                        (displayprompt.response.answer[1][1] === false) &&
                        <CircleIcon onClick={() => { !isLoading && onSubmitAnswer(displayprompt.id, displayprompt.response, displayprompt.response.answer[1][0]) }}></CircleIcon>
                    }

                   
                    <ScrollTextAnswer text={displayprompt.response.answer[1][0]}/>
                   
                  </div>
                </>
                )
            }
          

            {
               displayprompt.response.answer[2][0] && (
                <>
                <div className="promptTextPrompt, flex-container">
                  {
                   
                    (displayprompt.response.answer[2][1] === true) &&
                     
                          <>
                            {
                            (displayprompt.response.answer[2][2] === true && displayprompt.response.answer[2][3] === true ) &&
                              <CheckIcon/>
                            }
                            {
                            (displayprompt.response.answer[2][2] === true && displayprompt.response.answer[2][3] === false ) &&
                            <CancelIcon/>
                            }
                            {
                              displayprompt.response.answer[2][2] === false &&
                                  <>
                                      <CheckIcon onClick={() => { onAcceptAnswer(displayprompt, displayprompt.response.answer[2][0]) }} />
                                      <CancelIcon onClick={() => { onResetAnswer(displayprompt, displayprompt.response.answer[2][0]) }} />
                                  </>
                            }
                          </>
                  }
                      {
                          (displayprompt.response.answer[2][1] === false) &&
                          <CircleIcon onClick={() => { !isLoading && onSubmitAnswer(displayprompt.id, displayprompt.response, displayprompt.response.answer[2][0]) }}></CircleIcon>
                      }
                  
                 
                  <ScrollTextAnswer text={displayprompt.response.answer[2][0]}/>
                 
                </div>
                </>
              )
            }
           <br></br>
         </>
        )}
        </div>
      }
    </div>
  )
}


DisplayQuiz.defaultProps = {
  showprompts: true
};

export default DisplayQuiz
